import type { PreparedTextElement, TextEngineContext } from "./types";

function blockHeightDots(prepared: PreparedTextElement): number {
  const lineCount = Math.max(1, prepared.maxLines);
  return (
    prepared.fontHeightDots * lineCount +
    Math.max(0, lineCount - 1) * prepared.lineSpacingDots
  );
}

export function emitWithTbEngine(
  prepared: PreparedTextElement,
  ctx: TextEngineContext,
): void {
  const value = prepared.positioned.textValue ?? prepared.lines.join("\\&");
  const fieldData = ctx.prepareFieldData(value, ctx.encoding);

  ctx.zpl.push(`^FO${prepared.xDots},${prepared.yDots}`);
  ctx.zpl.push(
    `^A${prepared.family}N,${prepared.fontHeightDots},${prepared.fontWidthDots}`,
  );
  ctx.zpl.push(`^TBN,${prepared.widthDots},${blockHeightDots(prepared)}`);
  if (prepared.reversePrint) {
    ctx.zpl.push("^FR");
  }
  if (fieldData.useHex) {
    ctx.zpl.push("^FH_");
  }
  ctx.zpl.push(`^FD${fieldData.text}`);
  ctx.zpl.push("^FS");

  ctx.textDiagnostics.push({
    elementId: prepared.positioned.element.id,
    selectedEngine: "tb",
    wrapStrategy: "tb-native",
    lineCount: prepared.positioned.lineCount ?? prepared.lines.length,
    clipped: prepared.positioned.textOverflowed === true,
    ellipsized: prepared.positioned.textEllipsized === true,
    profileSource: "per-char",
  });
}
